import $ from 'jquery';
import Tips from '../Tips';
/* ===============================================================
  OTPWoocommerceLogin
=============================================================== */
class OTPWoocommerceLogin {
    constructor() {
        this.tip = new Tips();
        this.resendCooldown = iranthemeWpData.resend_cooldown_seconds;
        this.countdownInterval = null;
        this.resendOtpButton = $('#resend_otp_woo');
        this.events();
    }

    events() {
        this.initOTPAction();
        this.pageSwitching();
    }

    initOTPAction() {
        let current = this;

        // holder of otp login form wrapper
        let otpLoginFormWrapper = $('#irantheme_otp_login_form');

        // Get hidden field for hold user id
        let otpUserIdField = $('#otp_user_id_woo');

        // Send otp code
        otpLoginFormWrapper.on('submit', function (e) {
            if (
                $(e.originalEvent.submitter).attr('name') === 'request_otp_woo'
            ) {
                e.preventDefault();

                // Get content value
                let phoneNumber = $('#otp_phone_number_woo').val();

                // Initial validation of mobile number
                if (!phoneNumber || !/^(0?9[0-9]{9})$/.test(phoneNumber)) {
                    current.tip.createTip(
                        'warning',
                        'شماره موبایل وارد شده معتبر نیست. لطفاً با فرمت 09xxxxxxxxx یا 9xxxxxxxxx وارد کنید.',
                    );

                    // Exit the function if the number is not valid.
                    return;
                }
                let nonce_val = iranthemeWpData.security;

                // Get admin url ajax from demo
                var ajax_url = iranthemeWpData.adminAjax;

                $.ajax({
                    url: ajax_url,
                    type: 'post',
                    data: {
                        action: 'irantheme_ajax_request_otp_woo',
                        phone_number: phoneNumber,
                        nonce: nonce_val,
                    },
                    dataType: 'json',
                    beforeSend: (response) => {
                        $('#request_otp_woo').text('در حال ارسال...');
                    },
                    success: (response) => {
                        let jsonResponse = response;
                        let serverResendCooldown = current.resendCooldown;
                        if (jsonResponse.success) {
                            console.log('success: ' + jsonResponse.data.code);
                            console.log(
                                'success: ' + jsonResponse.data.current_ip,
                            );
                            current.tip.createTip(
                                'success',
                                jsonResponse.data.message,
                            );
                            // Hide get mobile number form
                            $('#otp_step_phone').fadeOut(150);
                            // Show verify code form
                            setTimeout(() => {
                                let verifyLabel = $(
                                    '.irantheme-login-otp-content-form-verify-label',
                                )
                                    .text()
                                    .replace('mobile_number', phoneNumber);
                                $(
                                    '.irantheme-login-otp-content-form-verify-label',
                                ).text(verifyLabel);
                                $('#otp_step_verify')
                                    .fadeIn(150)
                                    .css('display', 'block');

                                if (
                                    jsonResponse.data.resend_cooldown !==
                                    undefined
                                ) {
                                    serverResendCooldown =
                                        jsonResponse.data.resend_cooldown;
                                }
                                // Start countdown for resubmit button
                                current.startResendCountdown(
                                    serverResendCooldown,
                                );
                            }, 150);
                        } else if (jsonResponse.data.redirect_to_register) {
                            current.tip.createTip(
                                'warning',
                                jsonResponse.data.message,
                            );
                            $('.irantheme-login-otp-content').fadeOut(150);
                            setTimeout(() => {
                                $('.irantheme-register-content')
                                    .fadeIn(150)
                                    .css('display', 'flex');
                            }, 150);
                        } else if (
                            jsonResponse.data.code == 'sms_send_failed' ||
                            jsonResponse.data.code ==
                                'standardization_failed' ||
                            jsonResponse.data.code == 'too_many_otp_requests' ||
                            jsonResponse.data.code == 'too_many_otp_requests_ip'
                        ) {
                            current.tip.createTip(
                                'error',
                                jsonResponse.data.message,
                            );
                        } else if (
                            jsonResponse.data.code == 'user_locked_out' ||
                            jsonResponse.data.code == 'ip_locked_out'
                        ) {
                            current.tip.createTip(
                                'warning',
                                jsonResponse.data.message,
                            );
                        } else {
                            // General or unexpected errors
                            current.tip.createTip(
                                'warning',
                                jsonResponse.data.message,
                            );
                        }
                    },
                    complete: (response) => {
                        $('#request_otp_woo').text(
                            $('#request_otp_woo').attr('value'),
                        );
                    },
                    error: (response) => {
                        let jsonResponse = response;
                        console.log('Error: ' + jsonResponse.data.message);
                        current.tip.createTip(
                            'error',
                            'خطای ناخواسته، لطفا دقایقی دیگر مجددا تلاش کنید. درصورت بروز مجدد خطا با پشتیبانی تماس بگیرید.',
                        );
                    },
                });
            }
        });
        // Verify entered code
        otpLoginFormWrapper.on('submit', function (e) {
            if (
                $(e.originalEvent.submitter).attr('name') === 'verify_otp_woo'
            ) {
                e.preventDefault();
                let nonce_val = iranthemeWpData.security;
                // Get content value
                let phoneNumber = $('#otp_phone_number_woo').val();
                // Get otp entered code
                let otpCode = $('#otp_code_woo').val();
                // Initial validation of code and User ID
                if (!otpCode) {
                    current.tip.createTip(
                        'warning',
                        'کد اعتبارسنجی صحیح نمی باشد.',
                    );
                    return;
                }
                if (otpCode.length !== 6 || !/^\d{6}$/.test(otpCode)) {
                    current.tip.createTip(
                        'warning',
                        'کد اعتبارسنجی صحیح نمی باشد.',
                    );
                    return;
                }

                // Get admin url ajax from demo
                var ajax_url = iranthemeWpData.adminAjax;
                $.ajax({
                    url: ajax_url,
                    type: 'post',
                    data: {
                        action: 'irantheme_ajax_verify_otp_woo',
                        phone_number: phoneNumber,
                        otp_code: otpCode,
                        nonce: nonce_val,
                    },
                    dataType: 'json',
                    beforeSend: (response) => {
                        $('#verify_otp_woo').text('در حال بررسی...');
                    },
                    success: (response) => {
                        let jsonResponse = response;
                        if (jsonResponse.success) {
                            // console.log(
                            //     'success: ' + jsonResponse.data.message
                            // );
                            current.tip.createTip(
                                'success',
                                'ورود با موفقیت انجام شد. در حال هدایت به صفحه مورد نظر...',
                            );
                            // Redirect to myAccount page
                            window.location.href =
                                jsonResponse.data.redirect_url;
                        } else if (
                            jsonResponse.data.code == 'invalid_otp' ||
                            jsonResponse.data.code == 'user_not_found' ||
                            jsonResponse.data.code == 'otp_expired'
                        ) {
                            current.tip.createTip(
                                'warning',
                                jsonResponse.data.message,
                            );
                        } else if (
                            jsonResponse.data.code == 'too_many_attempts' ||
                            jsonResponse.data.code == 'user_locked_out' ||
                            jsonResponse.data.code ==
                                'too_many_otp_failed_attempts_lockout'
                        ) {
                            current.tip.createTip(
                                'error',
                                jsonResponse.data.message,
                            );
                        } else {
                            // General or unexpected errors
                            current.tip.createTip(
                                'warning',
                                jsonResponse.data.message,
                            );
                        }
                    },
                    complete: (response) => {
                        $('#verify_otp_woo').text(
                            $('#verify_otp_woo').attr('value'),
                        );
                    },
                    error: (response) => {
                        let jsonResponse = response;
                        console.log('Error: ' + jsonResponse.data.message);
                        current.tip.createTip(
                            'error',
                            'خطای ناخواسته، لطفا دقایقی دیگر مجددا تلاش کنید. درصورت بروز مجدد خطا با پشتیبانی تماس بگیرید.',
                        );
                    },
                });
            }
        });
        // Resend code
        $('#resend_otp_woo').on('click', function (e) {
            e.preventDefault();
            if (!$(e.target).hasClass('disabled')) {
                let nonce_val = iranthemeWpData.security;
                // Get phone number
                let phoneNumber = $('#otp_phone_number_woo').val();
                if (!phoneNumber) {
                    current.tip.createTip(
                        'warning',
                        'شماره موبایلی برای ارسال مجدد کد یافت نشد.',
                    );
                }

                // Get admin url ajax from demo
                var ajax_url = iranthemeWpData.adminAjax;
                $.ajax({
                    url: ajax_url,
                    type: 'post',
                    data: {
                        action: 'irantheme_ajax_request_otp_woo',
                        phone_number: phoneNumber,
                        nonce: nonce_val,
                    },
                    dataType: 'json',
                    beforeSend: (response) => {
                        $('#resend_otp_woo').text('در حال ارسال مجدد کد...');
                    },
                    success: (response) => {
                        let jsonResponse = response;
                        let serverResendCooldown = current.resendCooldown;
                        if (jsonResponse.success) {
                            console.log('success: ' + jsonResponse.data.code);
                            current.tip.createTip(
                                'success',
                                'کد اعتبار سنجی با موفقیت ارسال شد.',
                            );
                            // ** شروع شمارنده معکوس دکمه ارسال مجدد **
                            // اگر سرور یک مقدار resend_cooldown فرستاد، از آن استفاده کن.
                            if (
                                jsonResponse.data.resend_cooldown !== undefined
                            ) {
                                serverResendCooldown =
                                    jsonResponse.data.resend_cooldown;
                            }

                            // Start countdown for resubmit button
                            current.startResendCountdown(serverResendCooldown);
                        } else if (jsonResponse.data.redirect_to_register) {
                            current.tip.createTip(
                                'warning',
                                jsonResponse.data.message,
                            );
                            $('.irantheme-login-otp-content').fadeOut(150);
                            setTimeout(() => {
                                $('.irantheme-register-content')
                                    .fadeIn(150)
                                    .css('display', 'flex');
                            }, 150);
                        } else if (
                            jsonResponse.data.code == 'sms_send_failed'
                        ) {
                            current.tip.createTip(
                                'error',
                                jsonResponse.data.message,
                            );
                        } else if (
                            jsonResponse.data.code == 'standardization_failed'
                        ) {
                            current.tip.createTip(
                                'warning',
                                jsonResponse.data.message,
                            );
                        } else if (
                            jsonResponse.data.code == 'resend_cooldown_active'
                        ) {
                            current.tip.createTip(
                                'warning',
                                jsonResponse.data.message,
                            );
                        } else if (
                            jsonResponse.data.code == 'user_locked_out' ||
                            jsonResponse.data.code == 'ip_locked_out'
                        ) {
                            current.tip.createTip(
                                'warning',
                                jsonResponse.data.message,
                            );
                        } else if (
                            jsonResponse.data.code == 'too_many_otp_requests' ||
                            jsonResponse.data.code == 'too_many_otp_requests_ip'
                        ) {
                            current.tip.createTip(
                                'error',
                                jsonResponse.data.message,
                            );
                        } else {
                            // General or unexpected errors
                            current.tip.createTip(
                                'warning',
                                jsonResponse.data.message,
                            );
                        }
                    },
                    complete: (response) => {
                        $('#resend_otp_woo').text(
                            $('#resend_otp_woo').attr('data-value'),
                        );
                    },
                    error: (response) => {
                        let jsonResponse = response;
                        console.log('Error: ' + jsonResponse.data.message);
                        current.tip.createTip(
                            'error',
                            'خطای ناخواسته، لطفا دقایقی دیگر مجددا تلاش کنید. درصورت بروز مجدد خطا با پشتیبانی تماس بگیرید.',
                        );
                    },
                });
            }
        });
        // Edit phone number
        $('#edit_phone_number').on('click', function (e) {
            e.preventDefault();
            let nonce_val = iranthemeWpData.security;
            // Get phone number
            let phoneNumber = $('#otp_phone_number_woo').val();
            var ajax_url = iranthemeWpData.adminAjax;
            $.ajax({
                url: ajax_url,
                type: 'post',
                data: {
                    action: 'irantheme_reset_otp_restrictions',
                    phone_number: phoneNumber,
                    nonce: nonce_val,
                },
                dataType: 'json',
                beforeSend: (response) => {},
                success: (response) => {
                    let jsonResponse = response;
                    if (jsonResponse.success) {
                        console.log('success back to edit phone number');
                        // Hide get mobile number form
                        $('#otp_step_verify').fadeOut(150);
                        // Show verify code form
                        setTimeout(() => {
                            current.stopResendCountdown();
                            $('#otp_step_phone')
                                .fadeIn(150)
                                .css('display', 'block');
                        }, 150);
                    }
                },
                complete: (response) => {},
                error: (response) => {
                    let jsonResponse = response;
                    console.log('Error: ' + jsonResponse.data.message);
                },
            });
        });
    }

    startResendCountdown($resend_cooldown) {
        let current = this;
        // This value is in seconds
        let currentCooldown = $resend_cooldown;
        // If the counter is already active, clear it.
        if (current.countdownInterval) {
            clearInterval(current.countdownInterval);
        }
        // Disables the resubmit button and sets the initial text.
        current.resendOtpButton
            .addClass('disabled')
            .text(
                'مانده تا دریافت مجدد کد ' +
                    current.formatTimeForCountdown(currentCooldown),
            );

        // Every second decreases the countdown.
        current.countdownInterval = setInterval(function () {
            currentCooldown--;
            if (currentCooldown <= 0) {
                // If the countdown is over, it clears the interval and activates the button.
                clearInterval(current.countdownInterval);
                current.countdownInterval = null;
                current.resendOtpButton
                    .removeClass('disabled')
                    .text('ارسال مجدد کد');
            } else {
                // Update button text in minute:second format
                current.resendOtpButton.text(
                    'مانده تا دریافت مجدد کد ' +
                        current.formatTimeForCountdown(currentCooldown),
                );
            }
        }, 1000); // Runs every 1000 milliseconds (1 second)
    }

    stopResendCountdown() {
        let current = this;
        if (current.countdownInterval) {
            clearInterval(current.countdownInterval);
            // Reset variable
            current.countdownInterval = null;

            // Reset the button appearance to its original state
            current.resendOtpButton
                .removeClass('disabled')
                .text(current.resendOtpButton.attr('data-value'));
        }
    }

    formatTimeForCountdown(totalSeconds) {
        var minutes = Math.floor(totalSeconds / 60);
        var seconds = totalSeconds % 60;

        // Add zeros to the beginning of minutes and seconds if they are less than 10
        var formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        var formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

        return formattedMinutes + ':' + formattedSeconds;
    }
    // Switch between signIn and signUp page
    pageSwitching() {
        $('#irantheme_show_traditional_login').on('click', function (e) {
            $('.irantheme-login-otp-content').fadeOut(150);
            setTimeout(() => {
                $('.irantheme-login-content')
                    .fadeIn(150)
                    .css('display', 'flex');
            }, 150);
        });
        $('#irantheme_myaccount_registration_toggle_otp').on(
            'click',
            function (e) {
                $('.irantheme-login-otp-content').fadeOut(150);
                setTimeout(() => {
                    $('.irantheme-register-content')
                        .fadeIn(150)
                        .css('display', 'flex');
                }, 150);
            },
        );
    }
}
export default OTPWoocommerceLogin;
